export enum ToastBackgroundColor {
    Error = '#cc0000',
    Warning = '#f0ad4e',
    Success = '#339900',
    Information = '#000000',
}

export enum ToastTextColor {
    Error = '#ffffff',
    Warning = '#ffffff',
    Success = '#ffffff',
    Information = '#ffffff',
}
